// App-wide copy constants — CONTRACT FILE (director-owned).
// The three disclaimers are compliance surface (Regla No Negociable #3):
// placeholders ship now; final wording comes from securities counsel.
// Feature agents render these EXACT constants — never paraphrase them.

export const APP_NAME = "investPLY";

export const DISCLAIMER_DIRECTORY =
  "This directory is provided for informational purposes only. investPLY does not endorse or recommend any firm and does not provide investment advice. Tiers reflect reported assets under advisement, not quality rankings. [Placeholder — final wording pending securities counsel review.]";

export const DISCLAIMER_SUGGESTIONS =
  "Suggested firms are the result of the transparent filters you set — service type, client focus, geography, and minimum AUA — applied to the public directory. investPLY does not rank, score, or recommend firms. The decision of whom to invite is yours alone. [Placeholder — final wording pending securities counsel review.]";

export const DISCLAIMER_AI_PANEL =
  "AI assistance drafts document text from the inputs you provide. It does not evaluate, compare, or recommend consulting firms, and its output is not investment advice. Review and edit every AI-assisted section before publishing; sections that used AI assistance are flagged in your RFP's audit record. [Placeholder — final wording pending securities counsel review.]";

export const FOOTER_DISCLAIMER =
  "investPLY provides information and document tooling, not investment advice.";

// TEMPORARY (2026-08-04): founder-supplied inbox, stands in until investPLY
// has its own contact address on a verified domain. Referenced by the header
// CTA and every "get in touch" surface — including the ones that currently
// tell users to contact support without saying how (consultant /profile, the
// claim-rejected email). Change it here, nowhere else.
export const CONTACT_EMAIL = "paopau86@icloud.com";

// Shown on the public content pages (About / Our Services / Team). Same
// compliance surface as the three disclaimers above: the marketing pages are
// exactly where "we help you find a consultant" starts to read as a
// recommendation, which is the line this whole product is built to stay on
// the right side of.
export const DISCLAIMER_MARKETING =
  "investPLY is a directory and document platform. We do not endorse any consulting firm, rank firms by quality, or recommend whom to hire, and nothing on this site is investment advice. [Placeholder — final wording pending securities counsel review.]";

// Marks a page whose copy has NOT been approved yet. Deliberately visible to
// visitors rather than a code comment: the demo is published to the internet,
// so a draft nobody flagged reads as a finished claim about the business.
export const NOTICE_DRAFT_PENDING_REVIEW =
  "Draft — this page is a working proposal. Its wording has not been approved and is pending review by investPLY and its securities counsel.";
